import { Button, Col, Form, Input, Row, Select, Switch } from "antd"
import { useEffect, useState } from "react"
import { getConfiguration, updateConfiguration } from "../../appRedux/actions/Configuration"
import CircularProgress from "../../components/CircularProgress"
import PageContentWrapper from "../../components/PageContentWrapper"
import { useDispatch, useSelector } from "react-redux";
import { getParticipants, resetSession } from "../../appRedux/actions"

export default function Authentication() {
  const [oneSessionPerUser, setOneSessionPerUser] = useState(null)
  const [userId, setUserId] = useState(null)
  const [form] = Form.useForm()
  const dispatch = useDispatch()
  const { participants, participantsLoading } = useSelector(
    ({ participant }) => participant
  );
  const [searchParticipants, setSearchParticipants] = useState("");

  function onResetSession() {
    resetSession(userId)
  }

  useEffect(() => {
    getConfiguration("one_session_per_user")
      .then(data => {
        setOneSessionPerUser(data.value.toLowerCase() == "true" ? true : false)
      })
  }, [])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      dispatch(getParticipants({ page_size: 10, search: searchParticipants }));
    }, 200);
    return () => clearTimeout(timeoutId);
  }, [searchParticipants]);

  return <>
    {oneSessionPerUser == null ?
      <CircularProgress />
      :
      <PageContentWrapper title="Edit Otentikasi" backLink={"/configurations"}>
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            one_session_per_user: oneSessionPerUser,
          }}
          style={{ padding: 10 }}
          onFinish={() => { }}
          onValuesChange={(changedValues) => {
            for (const [key, value] of Object.entries(changedValues)) {
              updateConfiguration({
                name: key,
                value: value
              })
            }
          }}
        >
          <Form.Item
            name="one_session_per_user"
            label="Satu Sesi Per Pengguna?"
            valuePropName="checked"
          >
            <Switch checkedChildren="Ya" unCheckedChildren="Tidak" />
          </Form.Item>
          <Form.Item
            label="Reset Session"
          >
            <Input.Group compact>
              <Select
                showSearch
                onSearch={setSearchParticipants}
                filterOption={false}
                notFoundContent={null}
                loading={participantsLoading}
                style={{
                  width: 'calc(100% - 200px)',
                }}
                onChange={setUserId}
              >
                {participants.map((p) => (
                  <Select.Option key={p.id} value={p.id}>
                    {p.name} {`(${p.email})`} {p.whatsapp_number === null ? "- (Peserta tidak memiliki nomor whatsapp)" : ""}
                  </Select.Option>
                ))}
              </Select>
              <Button type="primary" onClick={onResetSession}>Reset</Button>
            </Input.Group>
          </Form.Item>
        </Form>
      </PageContentWrapper >
    }
  </>
}
